import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

const extractFilenameFromContentDisposition = (
  contentDisposition: string | undefined,
): string | null => {
  if (!contentDisposition) return null;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1].replace(/"/g, ''));

  const match = contentDisposition.match(/filename="?([^"]+)"?/i);
  if (match?.[1]) return match[1];

  return null;
};

const downloadBlob = (blob: Blob, filename: string) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const tryParseGenericError = async (
  blob: Blob,
): Promise<{ errCode?: string } | null> => {
  try {
    const text = await blob.text();
    const parsed = JSON.parse(text);
    if (parsed && typeof parsed === 'object' && 'errCode' in parsed) {
      return parsed as { errCode?: string };
    }
    return null;
  } catch {
    return null;
  }
};

export const downloadJournalEntryReportDatOperation = async (
  reportId: number,
  setLoading: (loading: boolean) => void,
): Promise<boolean> => {
  if (!reportId) {
    toast.warn('חסר מזהה דיווח להורדה');
    return false;
  }

  try {
    setLoading(true);

    const res = await appApi.downloadJournalEntryReportDat(reportId);
    const blob = res.data;

    const maybeErr = await tryParseGenericError(blob);
    if (maybeErr?.errCode) {
      toast.warn(displayErrorText(maybeErr.errCode));
      setLoading(false);
      return false;
    }

    const filenameFromHeader = extractFilenameFromContentDisposition(
      res.headers?.['content-disposition'],
    );
    const fallbackFilename = `journal_report_${reportId}.dat`;

    downloadBlob(blob, filenameFromHeader || fallbackFilename);
    toast.success('קובץ חשבשבת הורד בהצלחה');
    setLoading(false);
    return true;
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    return false;
  }
};
